import React from 'react';
import HeroGraphicUpdated from '../../../img/hero_graphic_updated.svg';
import HeroGraphicUpdatedV2 from '../../../img/hero_graphic_updated_v2.svg';
import FeatureFlags, {
  FeatureFlagKeys
} from '../../frontend-common-libs/src/components/feature_flags';
import { ExternalAnchorLink } from '../../frontend-common-libs/src/components/common/buttons';

export default function () {
  const isLandingPageV2 = FeatureFlags().get(FeatureFlagKeys.LANDING_PAGE_V2);
  const bannerGraphic = isLandingPageV2 ? HeroGraphicUpdatedV2 : HeroGraphicUpdated;

  const headingText = isLandingPageV2 ? 'Connect your lab with BR.io' : 'Connecting the Laboratory';

  const captionParagraph = isLandingPageV2
    ? 'Set up and monitor runs, analyze and share data, and manage instruments from anywhere at any time.'
    : 'The innovative BR.io cloud platform enables researchers to design and manage experiments from anywhere at any time.';

  return (
    <div className={`hero-banner${isLandingPageV2 ? ' hero-banner-v2' : ''}`}>
      <div className="caption">
        <h1>{headingText}</h1>
        <p>{captionParagraph}</p>
        {isLandingPageV2 && (
          <ExternalAnchorLink
            id="hero-learn-more-btn"
            className="hero-learn-more-btn"
            href="https://www.bio-rad.com/en-us/category/br-io-cloud-platform?ID=94d91ce9-d2ba-3f43-bdd6-e5216482515d"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn More
          </ExternalAnchorLink>
        )}
      </div>
      <div className="banner-images">
        <img src={bannerGraphic} className="banner-img" alt="hero graphic" />
        {!isLandingPageV2 && (
          <img src="img/early_access.png" className="early-access-label" alt="early access" />
        )}
      </div>
    </div>
  );
}
